<template>
  <div>
    <ui-modal
      :alignTop="true"
      :alignTopMargin="20"
      :removeHeader="false"
      ref="modal"
      title="Detalle de tracking de booking"
      class="modal-tracking"
      size="auto"
      @close="ActionSetVisibleModalVerTracking(false); ActionSetZindexTablaModal(false); clearData()">
      <div class="col-lg-12">

        <div class="card" v-for="(details, index) in data" :key="index">
          <div class="card-header">
            <div class="card-title">
              Detalle de tracking de contenedor No. {{ details.container_number }}
            </div>
          </div>
          <div class="card-body">
            <div class="col-lg-12">
              <fieldset-component
                class="mt-1 mb-3"
                :texto="'Información general'"
              ></fieldset-component>
              <div class="card">
                <div class="card-header" style="background-color: #f2f9ff">
                  <div class="row">
                    <div class="col-sm-2">
                      <p class="h6 text-center">
                        <b>No. Booking</b>
                        <br>
                        {{ details.booking_number }}
                      </p>
                    </div>
                    <div class="col-sm-2">
                      <p class="h6 text-center">
                        <b>No. Contenedor</b>
                        <br>
                        {{ details.container_number }}
                      </p>
                    </div>
                    <div class="col-sm-2">
                      <p class="h6 text-center">
                        <b>No. BL</b>
                        <br>
                        {{ details.events.current.bill_lading ?? "N/A" }}
                      </p>
                    </div>
                    <div class="col-sm-2" v-if="usuarioActual.id_role === 1 || usuarioActual.id_role === 9999 || usuarioActual.id_role === 2 || usuarioActual.id_role === 5">
                      <p class="h6 text-center">
                        <b>Última actualización</b>
                        <br>
                        {{ details.last_update }}
                      </p>
                    </div>
                    <div class="col-sm-2">
                      <p class="h6 text-center">
                        <span class="badge rounded-pill text-xl"
                              :class="details.arrived ? 'bg-success' : 'bg-danger'"
                              style="color: white !important; font-size: 1.0em !important;">
                          {{ details.arrived ? "Finalizado" : "En tránsito" }}</span>
                      </p>
                    </div>
                  </div>

                </div>
                <div class="card-body">
                  <h5 class="text-center m-3">
                    Tracking de Container No. {{ details.container_number }}
                  </h5>
                  <tracking-steps :data="details"></tracking-steps>
                </div>
                <div class="card-footer" style="background-color: #fff1f2">
                  <div class="row">
                    <div class="col-sm-2">
                      <p class="h6 text-center">
                        <b>Último movimiento</b>
                        <br>
                        {{ details.events.current !== null ? details.events.current.status_name : "N/A" }}
                      </p>
                    </div>
                    <div class="col-sm-2">
                      <p class="h6 text-center">
                        <b>Lugar</b>
                        <br>
                        {{ details.events.current !== null ? details.events.current.location + " - " + details.events.current.port_name : "N/A" }}
                      </p>
                    </div>
                    <div class="col-sm-2">
                      <p class="h6 text-center">
                        <b>Fecha</b>
                        <br>
                        {{ details.events.current !== null ? details.events.current.movement_date : "N/A" }}
                      </p>
                    </div>
                    <div class="col-sm-2">
                      <p class="h6 text-center">
                        <b>TT Real</b>
                        <br>
                        {{ details.transit_time }} días
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <DataTableTracking
              :data="details.movements"
              :buscar="true"
              :table_id="'tbl_tracking_bookings_' + index"
              :paginacion="true"
              :max="15">
            </DataTableTracking>

          </div>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";
import FieldsetComponent from "@/components/common/FieldsetComponent.vue";
import TrackingSteps from "@/components/common/skeletons/tracking/TrackingSteps.vue";
import { getTrackingDetails } from "@/constants/lineas";
import DataTableTracking from "@/components/dataTables/lineas/DataTableTracking.vue";

export default {
  components: {
    DataTableTracking,
    TrackingSteps,
    FieldsetComponent
  },
  props: {
    bookingNumber: {
      Default: Number
    }
  },
  data() {

    return {

      data: []

    };

  },
  computed: {

    ...mapState(["visibleModalVerTracking"]),

    ...mapState(["usuarioActual"])

  },

  methods: {

    ...mapActions([
      "ActionSetVisibleModalVerTracking",
      "ActionSetZindexTablaModal"
    ]),

    openModal(ref) {

      this.$refs[ref].open();

      this.ActionSetZindexTablaModal(true);

    },

    closeModal(ref) {

      this.$refs[ref].close();

    },

    clearData() {

      this.data = [];

    }

  },
  watch: {

    visibleModalVerTracking: async function(_new) {

      if (_new) {

        this.$vToastify.loader("Espere por favor...");

        try {

          const { status, data, message } = await getTrackingDetails({ booking_number: this.bookingNumber });

          if (status === 200) {

            this.data = data;

            this.openModal("modal");

            return this.$vToastify.stopLoader();

          } else if (status === 400) {

            this.$vToastify.stopLoader();

            this.ActionSetVisibleModalVerTracking(false);

            return this.$vToastify.info(message, "Booking sin tracking");

          } else {

            this.$vToastify.stopLoader();

            this.ActionSetVisibleModalVerTracking(false);

            return this.$vToastify.error(message, "Error de tracking");

          }

        } catch (error) {

          this.ActionSetVisibleModalVerTracking(false);

          this.$vToastify.stopLoader();

          return this.$vToastify.error("Se produjo un error inesperado", "Error");

        }

      }

    }

  }

};
</script>

<style>
.modal-tracking .ui-modal__container {
  width: 90% !important;
}
</style>
